import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import scrollbarWidth from 'scrollbar-width'

import './toggle-scroll.css'

document.addEventListener('DOMContentLoaded', () => {
  const sw = scrollbarWidth()
  setTimeout(() => {
    document.documentElement.style.setProperty('--scrollbar-width', `${sw}px`)
  }, 0)
})

const toggleScroll = (allow, scrollablePopup) => {
  if (!allow) {
    disableBodyScroll(scrollablePopup)
  }

  setTimeout(() => {
    // this line of code must be executed only with scrolling disabled to prevent jumps of scroll position
    document.documentElement.classList.toggle('scrollbar-hidden', !allow)

    if (allow) {
      enableBodyScroll(scrollablePopup)
    }
  }, 0)
}

export default toggleScroll
